import React from "react";
import { useParams, useRouteMatch } from "react-router-dom";
import { EventParamTypes } from "../../../types/types";
import { SubEventTable } from "../components/subEventTable/SubEventTable";
import { selectSubEvents } from "../../listEvents/listEventsReducer";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../history/history";
import BreadCrumb from "../../../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../../../components/breadcrumbs/BreadRoute";
import allActions from "../../../actions/allActions";

interface Props {}

export const SubEvents: React.FC<Props> = () => {
  const { id } = useParams<EventParamTypes>();
  const { list, headerRow, initLoading } = useSelector((state) =>
    selectSubEvents(state, id)
  );
  const { url } = useRouteMatch();
  const dispatch = useDispatch();

  const openSubEvent = (subEventId: string) => {
    history.push(`subevents/${subEventId}`);
  };

  const createSubEvent = () => {
    dispatch(allActions.eventActions.createSubEvent(id));
  };

  return (
    <div className='container w-screen h-screen'>
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} />
        <BreadCrumb label={"events"} link={"/events"} />
        <BreadCrumb label={`event ${id}`} link={`/events/${id}`} />
        <BreadCrumb label={`subevents`} link={`${url}`} lastChild={true} />
      </BreadRoute>
      <SubEventTable
        open={openSubEvent}
        createSubEvent={createSubEvent}
        headerRow={headerRow}
        tableList={list}
        loading={initLoading}
      />
    </div>
  );
};

export default SubEvents;
